import axios from '../../axios/index.js'

export default {
  complianceTableMatrix(){
    return axios.get('compliance/dashboard')
},
complianceTableList(){
    return axios.get('compliance/dashboardList')
},
    list (data) {
      return axios.post('compliance/list',data)
    },
    statusList(){
      return axios.get('compliance/status')
    },
    store (data) {
      return axios.post('compliance/store',data,{headers:{'Content-Type': 'multipart/form-data'}, processData:false, contentType:false})
    },
    update (data) {
      return axios.put('compliance/update',{ id: data.id, [data.column]: data.value })
    },
    updateExpiration (data) {
      return axios.post('compliance/expiration_date',data,{headers:{'Content-Type': 'multipart/form-data'}, processData:false, contentType:false})
    },
    updateComplianceLease (data) {
      return axios.post('compliance/leases',data,{headers:{'Content-Type': 'multipart/form-data'}, processData:false, contentType:false})
    },
    updateComplianceLeaseInsurance (data) {
      return axios.post('compliance/leases/insurance',data,{headers:{'Content-Type': 'multipart/form-data'}, processData:false, contentType:false})
    },
    delete (id) {
      return axios.delete('compliance/delete',{ params: { id } })
    },
    getCategories() {
      return axios.get('compliance/getCategories')
    },
    getTitles(data) {
      return axios.get('compliance/getTitles',{params:data})
    },
    getFrequencies() {
      return axios.get('compliance/getFrequencies')
    },
    getComplianceLeases(data) {
      return axios.get('compliance/show/'+data)
    },
    validate (data) {
      return axios.post('compliance/validate',data)
    },
}
  